import { request } from '../utils/httpClient';
import {
  ConversationListResponse,
  ConversationMessagesResponse,
  ConversationMessageCreateRequest,
  UnreadCountResponse,
  ConversationListParams,
  ConversationMessagesParams,
  MessageCreateRequest,
  MessageCreateResponse,
} from '../types/messages';

export const getConversations = (
  params: ConversationListParams = {}
): Promise<ConversationListResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page !== undefined)
    searchParams.append('page', params.page.toString());
  if (params.per_page !== undefined)
    searchParams.append('per_page', params.per_page.toString());
  if (params.sort) searchParams.append('sort', params.sort);
  if (params.order) searchParams.append('order', params.order);

  const url = `/messages/conversations/v2${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

  return request({
    url: url,
    method: 'GET',
  });
};

export const getConversationMessages = (
  params: ConversationMessagesParams
): Promise<ConversationMessagesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page !== undefined)
    searchParams.append('page', params.page.toString());
  if (params.per_page !== undefined)
    searchParams.append('per_page', params.per_page.toString());

  const url = `/messages/conversations/${params.id}/messages${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;
  return request({
    url: url,
    method: 'GET',
  });
};

export const createMessage = (
  data: ConversationMessageCreateRequest
): Promise<{ success: boolean }> => {
  const url = `/messages/conversations/${data.conversationId}/messages`;

  return request({
    url: url,
    method: 'POST',
    data: {
      message: data.message,
    },
  });
};

export const createMessageModal = (
  data: MessageCreateRequest
): Promise<MessageCreateResponse> => {
  const url = `/messages/create`;

  return request({
    url: url,
    method: 'POST',
    data: data,
  });
};

export const getUnreadCount = (): Promise<UnreadCountResponse> => {
  return request({
    url: `/messages/conversations/unread`,
    method: 'GET',
  });
};
